module.exports = "<main>\n  <h1>Hello from Angular 2 App with Webpack</h1>\n  <img src=\"" + require("../../public/images/angular.png") + "\">\n</main>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 285
 ** module chunks = 0
 **/